/**
 * tdesign v0.48.5
 * (c) 2022 tdesign
 * @license MIT
 */

import { h as helper } from '../../_chunks/dep-9d6f3de6.js';
import _defineProperty from '@babel/runtime/helpers/defineProperty';
import { defineComponent, toRefs, computed } from '@vue/composition-api';
import _typeof from '@babel/runtime/helpers/typeof';
import { c as createCommonjsModule } from '../../_chunks/dep-eb8a4de6.js';
import { BrowseIcon, DeleteIcon, CheckCircleFilledIcon, ErrorCircleFilledIcon, TimeFilledIcon } from 'tdesign-icons-vue';
import { useGlobalIcon } from '../../hooks/useGlobalIcon.js';
import { ImageViewer } from '../../image-viewer/index.js';
import { commonProps } from '../constants.js';
import { Button } from '../../button/index.js';
import useDrag from '../hooks/useDrag.js';
import { abridgeName, returnFileSize } from '../../_common/js/upload/utils.js';
import { Loading } from '../../loading/index.js';
import { Link } from '../../link/index.js';
import '../../hooks/useConfig.js';
import '../../config-provider/useConfig.js';
import '../../config-provider/context.js';
import 'lodash/merge';
import 'lodash/mergeWith';
import '../../_common/js/global-config/default-config.js';
import '../../_common/js/global-config/locale/zh_CN.js';
import '../../config-provider/type.js';
import '../../image-viewer/image-viewer.js';
import '@babel/runtime/helpers/slicedToArray';
import '../../image-viewer/props.js';
import '../../image-viewer/base/Container.js';
import 'vue';
import '../../utils/dom.js';
import 'raf';
import 'lodash/isString';
import '../../utils/easing.js';
import '../../image-viewer/base/ImageModalIcon.js';
import '../../hooks/tnode.js';
import 'lodash/isEmpty';
import 'lodash/isFunction';
import 'lodash/camelCase';
import 'lodash/kebabCase';
import '../../hooks/render-tnode.js';
import 'lodash/isObject';
import '../../image-viewer/base/ImageViewerUtils.js';
import '../../tooltip/index.js';
import '../../tooltip/tooltip.js';
import '../../tooltip/props.js';
import '../../popup/props.js';
import '../../popup/popup.js';
import '@popperjs/core';
import '../../utils/render-tnode.js';
import '../../utils/helper.js';
import '@babel/runtime/helpers/objectWithoutProperties';
import '../../_common/js/utils/set-style.js';
import '../../popup/container.js';
import '../../config-provider/config-receiver.js';
import '../../utils/mixins.js';
import '../../utils/map-props.js';
import '../../utils/withInstall.js';
import 'lodash/capitalize';
import './style/css.js';
import '../../tooltip/type.js';
import '../../image-viewer/utils.js';
import '../../image-viewer/base/ImageItem.js';
import '../../image-viewer/hooks.js';
import '../../image-viewer/base/ImageViewerModal.js';
import '../../dialog/index.js';
import '../../dialog/dialog.js';
import 'lodash/isNumber';
import 'lodash/throttle';
import '../../dialog/actions.js';
import '../../button/button.js';
import '../../button/props.js';
import '../../utils/ripple.js';
import '../../config.js';
import '../../loading/loading.js';
import '../../loading/icon/gradient.js';
import '../../_common/js/loading/circle-adapter.js';
import '../../_common/js/utils/helper.js';
import '@babel/runtime/helpers/toConsumableArray';
import '../../utils/transfer-dom.js';
import '../../loading/props.js';
import '../../loading/type.js';
import '../../loading/plugin.js';
import '../../button/type.js';
import '../../dialog/props.js';
import '../../utils/event.js';
import '../../hooks/useDestroyOnClose.js';
import '../../dialog/stack.js';
import '../../dialog/type.js';
import '../../dialog/plugin.js';
import '../../hooks/useVModel.js';
import '../../hooks/useDefaultValue.js';
import '../../image-viewer/const.js';
import '../../image-viewer/type.js';
import '../../_common/js/log/log.js';
import '../../link/link.js';
import '../../link/props.js';
import '../../link/type.js';

var classnames = createCommonjsModule(function (module) {
  /* global define */
  (function () {
    'use strict';

    var hasOwn = {}.hasOwnProperty;
    var nativeCodeString = '[native code]';

    function classNames() {
      var classes = [];

      for (var i = 0; i < arguments.length; i++) {
        var arg = arguments[i];
        if (!arg) continue;

        var argType = _typeof(arg);

        if (argType === 'string' || argType === 'number') {
          classes.push(arg);
        } else if (Array.isArray(arg)) {
          if (arg.length) {
            var inner = classNames.apply(null, arg);

            if (inner) {
              classes.push(inner);
            }
          }
        } else if (argType === 'object') {
          if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) {
            classes.push(arg.toString());
            continue;
          }

          for (var key in arg) {
            if (hasOwn.call(arg, key) && arg[key]) {
              classes.push(key);
            }
          }
        }
      }

      return classes.join(' ');
    }

    if ('object' !== 'undefined' && module.exports) {
      classNames["default"] = classNames;
      module.exports = classNames;
    } else if (typeof undefined === 'function' && _typeof(undefined.amd) === 'object' && undefined.amd) {
      // register as 'classnames', consistent with npm package name
      undefined('classnames', [], function () {
        return classNames;
      });
    } else {
      window.classNames = classNames;
    }
  })();
});

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var MultipleFlowList = defineComponent({
  name: "UploadMultipleFlowList",
  props: _objectSpread(_objectSpread({}, commonProps), {}, {
    uploadFiles: Function,
    cancelUpload: Function,
    dragEvents: Object,
    disabled: Boolean,
    isBatchUpload: Boolean,
    draggable: Boolean,
    onPreview: Function
  }),
  setup: function setup(props) {
    var _toRefs = toRefs(props),
        locale = _toRefs.locale,
        uploading = _toRefs.uploading,
        classPrefix = _toRefs.classPrefix;

    var uploadPrefix = "".concat(classPrefix.value, "-upload");
    var icons = useGlobalIcon({
      BrowseIcon: BrowseIcon,
      DeleteIcon: DeleteIcon,
      CheckCircleFilledIcon: CheckCircleFilledIcon,
      ErrorCircleFilledIcon: ErrorCircleFilledIcon,
      TimeFilledIcon: TimeFilledIcon
    });
    var drag = useDrag(props.dragEvents);
    var uploadText = computed(function () {
      if (uploading.value) return "".concat(locale.value.progress.uploadingText);
      return locale.value.triggerUploadText.normal;
    });
    var innerDragEvents = computed(function () {
      var draggable = props.draggable === void 0 ? true : props.draggable;
      return draggable ? {
        drop: drag.handleDrop,
        dragenter: drag.handleDragenter,
        dragover: drag.handleDragover,
        dragleave: drag.handleDragleave
      } : {};
    });
    return {
      icons: icons,
      dragActive: drag.dragActive,
      uploadPrefix: uploadPrefix,
      uploadText: uploadText,
      innerDragEvents: innerDragEvents
    };
  },
  methods: {
    getStatusMap: function getStatusMap() {
      var h = this.$createElement;
      var _this$icons = this.icons,
          CheckCircleFilledIcon = _this$icons.CheckCircleFilledIcon,
          ErrorCircleFilledIcon = _this$icons.ErrorCircleFilledIcon,
          TimeFilledIcon = _this$icons.TimeFilledIcon;
      var iconMap = {
        success: h(CheckCircleFilledIcon),
        fail: h(ErrorCircleFilledIcon),
        progress: h(Loading),
        waiting: h(TimeFilledIcon)
      };
      var progress = this.locale.progress;
      var textMap = {
        success: progress === null || progress === void 0 ? void 0 : progress.successText,
        fail: progress === null || progress === void 0 ? void 0 : progress.failText,
        progress: progress === null || progress === void 0 ? void 0 : progress.uploadingText,
        waiting: progress === null || progress === void 0 ? void 0 : progress.waitingText
      };
      return {
        iconMap: iconMap,
        textMap: textMap
      };
    },
    renderEmpty: function renderEmpty() {
      var h = this.$createElement;
      return h("div", {
        "class": "".concat(this.uploadPrefix, "__flow-empty")
      }, [this.dragActive ? this.locale.dragger.dragDropText : this.locale.dragger.clickAndDragText]);
    },
    renderImgItem: function renderImgItem(file, index) {
      var _this = this;

      var h = this.$createElement;

      var _this$getStatusMap = this.getStatusMap(),
          iconMap = _this$getStatusMap.iconMap,
          textMap = _this$getStatusMap.textMap;

      var _this$icons2 = this.icons,
          BrowseIcon = _this$icons2.BrowseIcon,
          DeleteIcon = _this$icons2.DeleteIcon;
      return h("li", {
        "class": "".concat(this.uploadPrefix, "__card-item"),
        "key": file.name + index + file.percent + file.status
      }, [h("div", {
        "class": classnames(["".concat(this.uploadPrefix, "__card-content"), _defineProperty({}, "".concat(this.classPrefix, "-is-bordered"), file.status !== "waiting")])
      }, [["fail", "progress"].includes(file.status) && h("div", {
        "class": "".concat(this.uploadPrefix, "__card-status-wrap")
      }, [iconMap[file.status], h("p", [textMap[file.status], file.status === "progress" ? " ".concat(file.percent, "%") : ""])]), (["waiting", "success"].includes(file.status) || !file.status && file.url) && h("img", {
        "class": "".concat(this.uploadPrefix, "__card-image"),
        "attrs": {
          "src": file.url || "//tdesign.gtimg.com/tdesign-default-img.png"
        }
      }), h("div", {
        "class": "".concat(this.uploadPrefix, "__card-mask")
      }, [file.url && h("span", {
        "class": "".concat(this.uploadPrefix, "__card-mask-item")
      }, [h(ImageViewer, {
        "attrs": {
          "images": this.displayFiles.map(function (t) {
            return t.url;
          }),
          "defaultIndex": index,
          "trigger": function trigger(h, _ref2) {
            var open = _ref2.open;
            return h(BrowseIcon, {
              "on": {
                "click": function click(_ref3) {
                  var _this$onPreview;

                  var e = _ref3.e;
                  (_this$onPreview = _this.onPreview) === null || _this$onPreview === void 0 ? void 0 : _this$onPreview.call(_this, {
                    file: file,
                    index: index,
                    e: e
                  });
                  open();
                }
              }
            });
          }
        }
      }), h("span", {
        "class": "".concat(this.uploadPrefix, "__card-mask-item-divider")
      })]), !this.disabled && h("span", {
        "class": "".concat(this.uploadPrefix, "__card-mask-item"),
        "on": {
          "click": function click(e) {
            return _this.onRemove({
              e: e,
              index: index,
              file: file
            });
          }
        }
      }, [h(DeleteIcon)])])]), h("p", {
        "class": "".concat(this.uploadPrefix, "__card-name")
      }, [abridgeName(file.name)])]);
    },
    renderStatus: function renderStatus(file) {
      var h = this.$createElement;

      var _this$getStatusMap2 = this.getStatusMap(),
          iconMap = _this$getStatusMap2.iconMap,
          textMap = _this$getStatusMap2.textMap;

      return h("div", {
        "class": "".concat(this.uploadPrefix, "__flow-status")
      }, [iconMap[file.status], h("span", [textMap[file.status], file.status === "progress" ? " ".concat(file.percent, "%") : ""])]);
    },
    renderNormalActionCol: function renderNormalActionCol(file, index) {
      var _this$locale,
          _this$locale$triggerU,
          _this2 = this;

      var h = this.$createElement;
      return h("td", [h(Button, {
        "attrs": {
          "theme": "primary",
          "variant": "text",
          "content": (_this$locale = this.locale) === null || _this$locale === void 0 ? void 0 : (_this$locale$triggerU = _this$locale.triggerUploadText) === null || _this$locale$triggerU === void 0 ? void 0 : _this$locale$triggerU["delete"]
        },
        "on": {
          "click": function click(e) {
            return _this2.onRemove({
              e: e,
              index: index,
              file: file
            });
          }
        }
      })]);
    },
    renderBatchActionCol: function renderBatchActionCol(index) {
      var _this$locale2,
          _this$locale2$trigger,
          _this3 = this;

      var h = this.$createElement;
      return index === 0 ? h("td", {
        "attrs": {
          "rowSpan": this.displayFiles.length
        },
        "class": "".concat(this.uploadPrefix, "__flow-table__batch-row")
      }, [h(Button, {
        "attrs": {
          "theme": "primary",
          "variant": "text",
          "content": (_this$locale2 = this.locale) === null || _this$locale2 === void 0 ? void 0 : (_this$locale2$trigger = _this$locale2.triggerUploadText) === null || _this$locale2$trigger === void 0 ? void 0 : _this$locale2$trigger["delete"]
        },
        "on": {
          "click": function click(e) {
            return _this3.onRemove({
              e: e,
              index: -1,
              file: null
            });
          }
        }
      })]) : null;
    },
    renderFileList: function renderFileList() {
      var _this$locale$file,
          _this$locale$file2,
          _this$locale$file3,
          _this$locale$file4,
          _this4 = this;

      var h = this.$createElement;
      return h("table", helper([{
        "class": "".concat(this.uploadPrefix, "__flow-table")
      }, {
        "on": this.innerDragEvents
      }]), [h("thead", [h("tr", [h("th", [(_this$locale$file = this.locale.file) === null || _this$locale$file === void 0 ? void 0 : _this$locale$file.fileNameText]), h("th", [(_this$locale$file2 = this.locale.file) === null || _this$locale$file2 === void 0 ? void 0 : _this$locale$file2.fileSizeText]), h("th", [(_this$locale$file3 = this.locale.file) === null || _this$locale$file3 === void 0 ? void 0 : _this$locale$file3.fileStatusText]), this.disabled ? null : h("th", [(_this$locale$file4 = this.locale.file) === null || _this$locale$file4 === void 0 ? void 0 : _this$locale$file4.fileOperationText])])]), h("tbody", [!this.displayFiles.length && h("tr", [h("td", {
        "attrs": {
          "colSpan": 4
        }
      }, [this.renderEmpty()])]), this.displayFiles.map(function (file, index) {
        var _this4$abridgeName;

        var showBatchUploadAction = _this4.isBatchUpload;
        var deleteNode = showBatchUploadAction && !_this4.displayFiles.find(function (item) {
          return item.status !== "success";
        }) ? _this4.renderBatchActionCol(index) : _this4.renderNormalActionCol(file, index);
        var fileName = (_this4$abridgeName = _this4.abridgeName) !== null && _this4$abridgeName !== void 0 && _this4$abridgeName.length ? abridgeName(file.name, _this4.abridgeName[0], _this4.abridgeName[1]) : file.name;
        return h("tr", {
          "key": file.name + index
        }, [h("td", [file.url ? h(Link, {
          "attrs": {
            "href": file.url,
            "target": "_blank",
            "hover": "color"
          }
        }, [fileName]) : fileName]), h("td", [returnFileSize(file.size)]), h("td", [_this4.renderStatus(file)]), _this4.disabled ? null : deleteNode]);
      })])]);
    }
  },
  render: function render() {
    var _this$$scopedSlots$de,
        _this$$scopedSlots,
        _this5 = this,
        _this$locale3;

    var h = arguments[0];
    var cardClassName = "".concat(this.uploadPrefix, "__flow-card-area");
    return h("div", {
      "class": "".concat(this.uploadPrefix, "__flow ").concat(this.uploadPrefix, "__flow-").concat(this.theme)
    }, [h("div", {
      "class": "".concat(this.uploadPrefix, "__flow-op")
    }, [(_this$$scopedSlots$de = (_this$$scopedSlots = this.$scopedSlots)["default"]) === null || _this$$scopedSlots$de === void 0 ? void 0 : _this$$scopedSlots$de.call(_this$$scopedSlots, null), this.placeholder && h("small", {
      "class": "".concat(this.uploadPrefix, "__flow-placeholder ").concat(this.uploadPrefix, "__placeholder")
    }, [this.placeholder])]), this.theme === "image-flow" && h("div", helper([{
      "class": cardClassName
    }, {
      "on": this.innerDragEvents
    }]), [this.displayFiles.length ? h("ul", {
      "class": "".concat(this.uploadPrefix, "__card clearfix")
    }, [this.displayFiles.map(function (file, index) {
      return _this5.renderImgItem(file, index);
    })]) : this.renderEmpty()]), this.theme === "file-flow" && (this.displayFiles.length ? this.renderFileList() : h("div", helper([{
      "class": cardClassName
    }, {
      "on": this.innerDragEvents
    }]), [this.renderEmpty()])), !this.autoUpload && h("div", {
      "class": "".concat(this.uploadPrefix, "__flow-bottom")
    }, [h(Button, {
      "attrs": {
        "theme": "default",
        "disabled": this.disabled || !this.uploading,
        "content": (_this$locale3 = this.locale) === null || _this$locale3 === void 0 ? void 0 : _this$locale3.cancelUploadText
      },
      "on": {
        "click": function click(e) {
          var _this5$cancelUpload;

          return (_this5$cancelUpload = _this5.cancelUpload) === null || _this5$cancelUpload === void 0 ? void 0 : _this5$cancelUpload.call(_this5, {
            e: e
          });
        }
      }
    }), h(Button, {
      "attrs": {
        "disabled": this.disabled || this.uploading || !this.displayFiles.length,
        "theme": "primary",
        "loading": this.uploading,
        "content": this.uploadText
      },
      "on": {
        "click": function click() {
          var _this5$uploadFiles;

          return (_this5$uploadFiles = _this5.uploadFiles) === null || _this5$uploadFiles === void 0 ? void 0 : _this5$uploadFiles.call(_this5);
        }
      }
    })])]);
  }
});

export { MultipleFlowList as default };
//# sourceMappingURL=multiple-flow-list.js.map
